import { Component, OnDestroy, OnInit} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { ChartType } from 'chart.js';
import { MultiDataSet, Label, PluginServiceGlobalRegistrationAndOptions} from 'ng2-charts';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators'
import endpoints from 'src/app/helpers/endpoints';

@Component({
  selector: 'fury-statistics-review',
  templateUrl: './statistics-review.component.html',
  styleUrls: ['./statistics-review.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class StatisticsReviewComponent implements OnInit, OnDestroy {

  statisticsReviewData!:any;
  loading!:boolean;
  size = 12;
  ngUnsubscribe = new Subject<void>();
  loadingMoreDetails = false;
  totalCount = 0;
  public doughnutChartLabels: string[] = [ 'Total visits', 'Unique visits'];
  public doughnutChartData: MultiDataSet = [];
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutChartPlugins: PluginServiceGlobalRegistrationAndOptions[] = [
    {
      beforeDraw(chart: any) {
        const ctx = chart.ctx;
        const txt = 'Center Text';

        //Get options from the center object in options
        const sidePadding = 60;
        const sidePaddingCalculated =
          (sidePadding / 100) * (chart.innerRadius * 2);

        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
        const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

        //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
        const stringWidth = ctx.measureText(txt).width;
        const elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

        // Find out how much the font can grow in width.
        const widthRatio = elementWidth / stringWidth;
        const newFontSize = Math.floor(30 * widthRatio);
        const elementHeight = chart.innerRadius * 2;

        // Pick a new font size so it will not be larger than the height of label.
        const fontSizeToUse = Math.min(newFontSize, elementHeight);

        ctx.font = fontSizeToUse + 'px Arial';
        ctx.fillStyle = 'blue';

        // Draw text in center
        // ctx.fillText('Center Text', centerX, centerY);
      },
    },
  ];
  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.getStatisticsReview();
  }
  getStatisticsReview(){
    this.loading = true;
    this.apiService.get(`${endpoints.reputation.statisticsReview.statisticsReview}?page=1&size=${this.size}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:HttpResponse<any>)=>{   
     if(res.body?.statistics){
      this.loading = false;
      this.statisticsReviewData = res?.body?.statistics;
      this.doughnutChartData = [[res?.body?.statistics?.summary?.totalVisits, res?.body?.statistics?.summary?.uniqueVisits]];
      this.totalCount = res.body?.statistics?.detailsCount;
     }
    }, err =>{
      this.loading = false;
    })
  }
  // events
  public chartClicked({
    event,
    active,
  }: {
    event: MouseEvent;
    active: {}[];
  }): void {
   
  }

  public chartHovered({
    event,
    active,
  }: {
    event: MouseEvent;
    active: {}[];
  }): void {
    
  }
  loadMoreDetails(){
    this.size = this.size + 12;
    this.loadingMoreDetails = true;
    this.apiService.get(`${endpoints.reputation.statisticsReview.statisticsReview}?page=1&size=${this.size}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: HttpResponse<any>) => {
        this.loadingMoreDetails = false;
        this.statisticsReviewData = res?.body?.statistics;
        this.totalCount = res.body?.statistics?.detailsCount;
        this.scrolltoBottomPosition();
      },
      error: (err: HttpErrorResponse) => {
        this.loadingMoreDetails = false;
      }
    })
  }
  scrolltoBottomPosition() {
    
    const element = document.querySelector('#bottomPosition');
    if (element) {
      setTimeout(() => {
        element.scrollIntoView(false);
      }, 100);
    }
  };
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
